import Input from 'client/components/core/Sidebar/components/Settings/components/Input'
import PropTypes from 'prop-types'
import React from 'react'

const UrlRedirect = ({ update, urlRedirect = '', ...rest }) => (
  <Input
    labelText="Redirection url"
    update={update}
    value={urlRedirect}
    placeholder=""
    {...rest}
  />
)

UrlRedirect.propTypes = {
  update: PropTypes.func.isRequired,
  urlRedirect: PropTypes.string,
}

export default UrlRedirect
